<template>
	<div>
		<topback title="Deposit USDT" path="back">
			<template slot="right">
				<iconimg class="rechargelog-img" name="deposithistory" @click="go_deposithistory"></iconimg>
			</template>
		</topback>
		<div class="usdt-header">
			<md-notice-bar
				icon="coupon"
				type="activity"
				>
				{{ usdt_inrtext }}
			</md-notice-bar>
			<div class="usdt-amount">
				<md-amount :value="amount" has-separator></md-amount>
				<span>USDT</span>
			</div>
			<vue-qr :text="usdt_address" :size="160" :margin="0" ref="qrcode"></vue-qr>
			<span>Send Only USDT to this deposit address.</span>
		</div>

		<div class="usdt-info">
			<md-cell-item title="Wallet Address" :brief="usdt_address">
				<img src="/static/icon/copy.png" class="copy cell-img" :data-clipboard-text="usdt_address" slot="right"
					@click="onCopyAddressSuccess" />
			</md-cell-item>
			<md-cell-item title="Network" brief="Tron(TRC20)">
				<img src="/static/icon/network.png" class="cell-img" slot="right" />
			</md-cell-item>
		</div>

		<div class="usdt-comfir">
			<!-- <div class="info">
				<span>Minimum deposit</span>
				<span>>0.01 USDT</span>
			</div> -->
			<div class="info">
				<span>Expected arrival</span>
				<span>1 network confirmation</span>
			</div>
			<div class="info">
				<span>Expected unlock</span>
				<span>1 network confirmation</span>
			</div>
			<div class="info">
				<span>Contract Information</span>
				<span>***jLj6t</span>
			</div>
		</div>

		<div class="usdt-btn">
			<md-button type="default" inline @click="downloadImage">Save Image</md-button>
			<md-button class="copy" type="primary" inline :data-clipboard-text="usdt_address"
				@click="onCopyAddressSuccess">Copy Address</md-button>
		</div>
	</div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import Clipboard from "clipboard"
import VueQr from 'vue-qr'
import { rechargequota } from '@/request/api'


export default {
	name: 'depositusdt',
	components: {
		[topback.name]: topback,
		[iconimg.name]: iconimg,
		VueQr
	},

	data() {
		return {
			usdt_address: "",
			usdt_inrtext: "",
		}
	},
	created() {
		this.amount = Number(this.$route.params.amount);
		this.$toast.loading("Loading...");
		this.$store.dispatch("asyncupdatesiteconfig").then(res=>{
			this.get_address();
		});
	},

	methods: {
		get_address() {
			let that = this;
			rechargequota({
				method: 'usdt',
				amount: this.amount.toFixed(2)
			}).then(res => {
				this.$toast.hide();
				if (res.code === 200) {
					let itoken = this.calculate_usdt_to_itoken(this.amount.toFixed(2), Number(1 / res.data.rs_dui_usdt_rate).toFixed(2))
					this.usdt_inrtext = "You will receive: " + itoken + " Itoken ";
					this.usdt_address = res.data.tokon_address;
				} else {
					this.$toast.failed(res.errmsg);
				}
			})
		},
		calculate_usdt_to_itoken(newVal, exchangerate) {
            newVal = Number(newVal);
			let gift = 0
			if(newVal > Number(this.$store.state.siteconfig.cw_usdt_recharge_reward_minamount)) {
				gift = Number(this.$store.state.siteconfig.cw_usdt_recharge_reward) * exchangerate;
			}
			let principal = newVal * exchangerate
			let principal_reward = newVal * Number(this.$store.state.userinfo.bonus_ratio) * Number("0.01") * exchangerate;
			let reward = principal_reward + gift;
			let get_itoken = principal + reward;
			return get_itoken
        },
		go_deposithistory() {
			this.$router.push("/deposithistory")
		},
		downloadImage() {
			const iconUrl = this.$refs.qrcode.$el.src
			const a = document.createElement('a')
			const event = new MouseEvent('click')
			a.download = "itoken.png"
			a.href = iconUrl
			a.dispatchEvent(event)
		},
		onCopyAddressSuccess() {
			let clipboard = new Clipboard('.copy')
			clipboard.on('success', () => {
				this.$toast.succeed('copy successfully');
				clipboard.destroy()
			})
			clipboard.on('error', () => {
				this.$toast.failed("Browser does not support copying")
				clipboard.destroy()
			})
		}
	}
}

</script>
<style scoped>
.usdt-header {
	margin-top: 0.99rem;
	text-align: center;
	border-bottom-width: 2px;
	border-bottom-style: groove;
	border-bottom-color: rgb(192, 192, 192);
	padding-bottom: 0.5rem;
}

.usdt-header span {
	display: block;
	font-size: 0.1rem;
}

.usdt-info .cell-img {
	width: 0.5rem;
}

.usdt-info>>>.md-cell-item-title {
	color: #858b9c;
	font-size: 0.21rem;
}

.usdt-info>>>.md-cell-item-brief {
	color: black;
	font-size: 0.26rem;
	line-height: 1.4;
	margin-top: 0.08rem;
	width: 6rem;
	word-wrap: break-word;
}

.usdt-comfir {
	box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
	padding: 10px;
}

.usdt-comfir span {
	font-size: 0.1rem;
}

.usdt-comfir .info {
	display: flex;
	justify-content: space-between;
	margin: 10px 10px 12px 7px;
}

.usdt-btn {
	position: fixed;
	left: 0;
	right: 0;
	margin: 0 auto;
	bottom: 15px;
	text-align: center;
	width: 100%;
}

.rechargelog-img {
	width: 0.4rem;
}

.usdt-amount {
	display: flex;
	justify-content: center;
	margin-bottom: 0.3rem;
	margin-top: 0.3rem;
}

.usdt-amount span {
	font-size: 0.45rem;
	margin-left: 0.2rem;
}</style>



// WEBPACK FOOTER //
// src/views/recharge/depositusdt.vue